const shared = {
	allowSubmit: true
};

export default shared;
